import { actions, types } from './requests'
export const GETARTICLELIST_TYPES = {
    ...types('GETARTICLELIST'),
}
export const GETARTICLELIST_ACTIONS = {
    ...actions('GETARTICLELIST'),
}
